<style>
.medical-document__header {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 2rem;
  width: 100%;
}

.medical-document__title {
  color: #000000;
  font-family: 'Quicksand';
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 !important;
  padding: 0;
  width: auto;
}

.medical-document__logo {
  height: auto;
  width: 200px;
}

.medical-document__issue-date {
  color: rgb(68, 68, 68);
  font-family: 'Open Sans';
  font-size: 0.75rem;
  font-weight: 600;
  flex: 0 0 100%;
  margin: 1rem 0;
}

.medical-document__info {
  border-bottom: 1px solid rgb(221, 221, 221);
  border-top: 1px solid rgb(221, 221, 221);
  display: flex;
  flex-direction: row;
  flex: 0 0 100%;
  margin-bottom: 1rem;
  padding: 1rem 0;
  width: 100%;
}

.medical-document__info-col {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 50%;
  flex-direction: column;
  justify-content: flex-start;
}

.medical-document__info-title {
  color: rgb(153, 153, 153);
  font-family: 'Open Sans';
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 2px;
  margin: 0 0 0.5rem 0;
  padding: 0;
  text-transform: uppercase;
}

.medical-document__info-name {
  color: rgb(68, 68, 68);
  font-family: 'Open Sans';
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  padding: 0;
}

.medical-document__info-data {
  color: rgb(68, 68, 68);
  font-family: 'Open Sans';
  font-size: 0.9rem;
  margin: 0 0 0.5rem 0;
  padding: 0;
}

.medical-document__info-data--address {
  font-size: 0.7rem;
}
</style>

<template>
  <header class="medical-document__header">
    <h1 class="medical-document__title">
      {{ type }}
    </h1>

    <img
      src="@/assets/img/home/logo_web.png"
      class="medical-document__logo"
    />

    <div class="medical-document__issue-date">
      Emitido em {{ date }}
      <template v-if="via === 1">
        - 1<sup>a</sup> Via Farmácia
      </template>

      <template v-if="via === 2 ">
        - 2<sup>a</sup> Via Paciente
      </template>
    </div>

    <div class="medical-document__info">
      <div class="medical-document__info-col">
        <p class="medical-document__info-title">
          Prescrito por:
        </p>

        <h2 class="medical-document__info-name">
          D{{ doctor.user.gender === 'M' ? 'r. ' : 'ra.' }}
          {{ doctor['display_name'] }}
        </h2>

        <p class="medical-document__info-data">
          CRM {{ doctor.crm }}/{{ doctor['crm_regional'] }}
        </p>

        <p
          class="medical-document__info-data medical-document__info-data--address"
          v-html="address"
        />
      </div>

      <div class="medical-document__info-col">
        <p class="medical-document__info-title">
          Paciente:
        </p>

        <h2 class="medical-document__info-name">
          {{ patient.name }}
        </h2>

        <p
          v-if="patient.cpf"
          class="medical-document__info-data"
        >
          CPF {{ patient.cpf | TO_CPF }}
        </p>

        <p
          v-if="patient.rg"
          class="medical-document__info-data"
        >
          RG {{ patient.rg }}
        </p>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'DrPrintTemplateHeader',

  props: {
    doctor: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    patient: {
      type: Object,
      required: true
    },

    date: {
      type: String,
      required: true
    },

    via: {
      type: Number,
      required: false,
      default: () => 0
    }
  },

  computed: {
    address () {
      if (
        this.doctor &&
        'doctor_offices' in this.doctor &&
        this.doctor['doctor_offices'].length > 0
      ) {
        const { address } = this.doctor['doctor_offices']
          .find((office) => office.type === 'FACETOFACE')

        return `${address.street} ${address.number} ${address.complement ? address.complement : ''} - ${address.district}
          <br>
          ${address.city.name}/${address.uf.name} CEP ${address.cep.substring(0, 5)}-${address.cep.substring(5)}`
      }

      return ''
    }
  },

  mounted () {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'hidden'
  },

  destroyed () {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'initial'
  }
}
</script>
